module.exports = __webpack_public_path__ + "img/lasource-13.4d816ba5.jpg";